
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/gcp-workload-identity-federation",
      function () {
        return require("private-next-pages/learn/gcp-workload-identity-federation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/gcp-workload-identity-federation"])
      });
    }
  